import React, { useRef } from 'react';

import { Container, StyledTextArea, Error } from './styles';

export interface Props {
  error?: string;
  [key: string]: any;
}

const TextArea = ({ error, ...props }: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <div ref={ref}>
      <Container>
        <StyledTextArea rows={10} styledProps={{ hasError: Boolean(error) }} {...props} />
      </Container>
      {error && <Error>{error}</Error>}
    </div>
  );
};

export default TextArea;
